var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import { handlePlansCheck, handleTVEPlansCheck } from "../../components/MonetizationBadge/helper";
import { fetchAuthenticationStoreData, isTvodSubscribed } from "../../Hardwall/helper";
import { fetchUserDetails, getToken } from "../../helpers";
export var checkUserCheckoutFlow = function (contentData) { return __awaiter(void 0, void 0, void 0, function () {
    var usersObject, user, tveProvider, freePreview, isFreePreview, monetizationModels, hasFreeEpisode, isTveModel, isSvodModel, isTvodModel, isAvodModel, checkFreePreviewFlow, isSubscribed, isUserTvodSubscribed, isTveAutherized;
    var _a, _b, _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0: return [4 /*yield*/, fetchAuthenticationStoreData()];
            case 1:
                usersObject = _g.sent();
                user = usersObject.user, tveProvider = usersObject.tveProvider;
                freePreview = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.features) === null || _c === void 0 ? void 0 : _c.free_preview;
                isFreePreview = (freePreview === null || freePreview === void 0 ? void 0 : freePreview.isFreePreview) || false;
                monetizationModels = ((_d = contentData === null || contentData === void 0 ? void 0 : contentData.monetizationModels) === null || _d === void 0 ? void 0 : _d.filter(function (plan) { return plan === null || plan === void 0 ? void 0 : plan.type; })) || [];
                hasFreeEpisode = monetizationModels === null || monetizationModels === void 0 ? void 0 : monetizationModels.some(function (model) { return (model === null || model === void 0 ? void 0 : model.type) === "FREE"; });
                isTveModel = monetizationModels === null || monetizationModels === void 0 ? void 0 : monetizationModels.some(function (model) { return (model === null || model === void 0 ? void 0 : model.type) === "TVE"; });
                isSvodModel = monetizationModels === null || monetizationModels === void 0 ? void 0 : monetizationModels.some(function (model) { return (model === null || model === void 0 ? void 0 : model.type) === "SVOD"; });
                isTvodModel = monetizationModels === null || monetizationModels === void 0 ? void 0 : monetizationModels.some(function (model) { return (model === null || model === void 0 ? void 0 : model.type) === "TVOD"; });
                isAvodModel = monetizationModels === null || monetizationModels === void 0 ? void 0 : monetizationModels.some(function (model) { return (model === null || model === void 0 ? void 0 : model.type) === "AVOD"; });
                checkFreePreviewFlow = function () { return (isFreePreview && !hasFreeEpisode) || (!isFreePreview && !hasFreeEpisode); };
                // to handle unauthenticated users
                if (!user) {
                    if (isAvodModel) {
                        return [2 /*return*/, false];
                    }
                    else {
                        return [2 /*return*/, checkFreePreviewFlow()];
                    }
                }
                isSubscribed = handlePlansCheck(user, contentData === null || contentData === void 0 ? void 0 : contentData.plans);
                return [4 /*yield*/, isTvodSubscribed((_e = contentData === null || contentData === void 0 ? void 0 : contentData.gist) === null || _e === void 0 ? void 0 : _e.id)];
            case 2:
                isUserTvodSubscribed = _g.sent();
                isTveAutherized = tveProvider;
                if (tveProvider && ((_f = user === null || user === void 0 ? void 0 : user.subscription) === null || _f === void 0 ? void 0 : _f.tveSubscriptions)) {
                    isTveAutherized = handleTVEPlansCheck(user, contentData === null || contentData === void 0 ? void 0 : contentData.plans);
                }
                // TVE and SVOD models
                if (hasFreeEpisode) {
                    return [2 /*return*/, !hasFreeEpisode];
                }
                if (isAvodModel) {
                    return [2 /*return*/, !isAvodModel];
                }
                if (isTveModel && isSvodModel) {
                    return [2 /*return*/, !(isSubscribed || isTveAutherized)];
                }
                if (isTveModel) {
                    return [2 /*return*/, !isTveAutherized];
                }
                if (isSvodModel) {
                    return [2 /*return*/, !isSubscribed];
                }
                if (isTvodModel) {
                    return [2 /*return*/, !isUserTvodSubscribed];
                }
                return [2 /*return*/, checkFreePreviewFlow()];
        }
    });
}); };
export var fetchSeriesData = function (contentData) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, userId, hba, apiBaseUrl, contentId, locationCoordsData, locationCoords, latitudeCoords, longitudeCoords, token, params, res, e_1, plans;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    return __generator(this, function (_p) {
        switch (_p.label) {
            case 0:
                _p.trys.push([0, 4, , 5]);
                return [4 /*yield*/, fetchUserDetails()];
            case 1:
                _a = _p.sent(), userId = _a.userId, hba = _a.hba;
                apiBaseUrl = (_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.app_data) === null || _b === void 0 ? void 0 : _b.appcmsMain) === null || _c === void 0 ? void 0 : _c.apiConfig) === null || _d === void 0 ? void 0 : _d.apiBaseUrl;
                contentId = (_e = contentData === null || contentData === void 0 ? void 0 : contentData.gist) === null || _e === void 0 ? void 0 : _e.id;
                locationCoordsData = sessionStorage.getItem("locationCoords");
                locationCoords = JSON.parse(locationCoordsData);
                latitudeCoords = (_g = (_f = hba === null || hba === void 0 ? void 0 : hba.latitude) !== null && _f !== void 0 ? _f : locationCoords === null || locationCoords === void 0 ? void 0 : locationCoords.latitude) !== null && _g !== void 0 ? _g : null;
                longitudeCoords = (_j = (_h = hba === null || hba === void 0 ? void 0 : hba.longitude) !== null && _h !== void 0 ? _h : locationCoords === null || locationCoords === void 0 ? void 0 : locationCoords.longitude) !== null && _j !== void 0 ? _j : null;
                return [4 /*yield*/, getToken(function (token) { return token; })];
            case 2:
                token = _p.sent();
                params = {
                    id: contentId,
                    deviceType: "web_browser",
                    contentConsumption: "web",
                    latitude: latitudeCoords,
                    longitude: longitudeCoords
                };
                return [4 /*yield*/, axios.get("".concat(apiBaseUrl, "/v3/entitlement/series"), {
                        params: params,
                        headers: {
                            authorization: token
                        }
                    })];
            case 3:
                res = _p.sent();
                return [2 /*return*/, (_l = (_k = res === null || res === void 0 ? void 0 : res.data) === null || _k === void 0 ? void 0 : _k.series) === null || _l === void 0 ? void 0 : _l.plans];
            case 4:
                e_1 = _p.sent();
                plans = (_o = (_m = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _m === void 0 ? void 0 : _m.data) === null || _o === void 0 ? void 0 : _o.plans;
                return [2 /*return*/, (plans === null || plans === void 0 ? void 0 : plans.length) && plans || []];
            case 5: return [2 /*return*/];
        }
    });
}); };
